// Business types offered on the referral-partner form. A plain module (not
// 'use client') because the API route re-validates against it — a type the
// server doesn't know is dropped rather than mailed or tracked as free text.
//
// `id` is what tracking and any future partners table group on, so it is
// stable; `label` is display copy and can be reworded freely.
export const PARTNER_TYPES = [
  { id: "physio", label: "Physiotherapy / sports therapy" },
  { id: "fitness", label: "Personal training / gym" },
  { id: "aesthetics", label: "Aesthetics / cosmetic clinic" },
  { id: "medical", label: "Surgeon / medical practice" },
  { id: "beauty", label: "Beauty / salon / spa" },
  { id: "wellness", label: "Wellness / holistic therapy" },
  { id: "other", label: "Other" },
] as const;

export type PartnerTypeId = (typeof PARTNER_TYPES)[number]["id"];

export function partnerTypeLabel(id: unknown): string | null {
  return PARTNER_TYPES.find((t) => t.id === id)?.label ?? null;
}

/**
 * Blog posts shown to referral partners — on the #partners section and in their
 * confirmation email. Ordered by who they speak to: the gym/athlete post is
 * written for the people who'd refer ("The Recovery Tool Your Clients Need"),
 * then post-op (physios, surgeons), DOMS (PTs), and the general overview last.
 * Resolved through getBlogsBySlugs, so a pulled post simply drops out.
 */
export const PARTNER_READING = [
  "body-ballancer-pro-for-athletes-and-gym-members-southport",
  "lymphatic-drainage-after-knee-replacement",
  "doms-recovery-preston",
  "body-ballancer-lymphatic-drainage-for-everyday-life",
] as const;
